import FouGrid from 'components/layout/fou-grid/'
import FouGroup from 'components/layout/fou-group/'
import FouContainer from 'src/components/tools/fou-container/'
import Misc from 'src/utils/helper/misc'
import Content from 'src/assets/i18n/en.json'
import get from 'lodash/get'

export default {
  name: 'message-history',
  data: function () {
    return {
      messageSectionVisible: false,
      expandButtonText: get(
        Content,
        'pages.submissions.review.message_history_btn.more'
      )
    }
  },
  components: {
    FouContainer,
    ...FouGrid,
    FouGroup
  },
  props: ['messageHistory'],
  methods: {
    ...Misc,
    setMessageSectionVisible() {
      if (this.messageSectionVisible) {
        this.messageSectionVisible = false
        this.expandButtonText = get(
          Content,
          'pages.submissions.review.message_history_btn.more'
        )
      } else {
        this.messageSectionVisible = true
        this.expandButtonText = get(
          Content,
          'pages.submissions.review.message_history_btn.less'
        )
      }
    }
  }
}
